/* =Main js
 ----------------------------------------------- */
(function ($) {

    // Show to top, header shadow and paralax hero
    const toTop = $('.to-top');
    const header = $('.site-header');
    const hero = $('.hero-section');
    
    $(window).on('scroll', () => {
        const scrollTop = $(window).scrollTop();
        if (scrollTop > 1) {
            header.addClass('scrolling');
        }
        if (scrollTop > header.height() * 2) {
            toTop.addClass('fadeIn');
        }
        if (scrollTop === 0) {
            header.removeClass('scrolling');
            toTop.removeClass('fadeIn');
        }
        if (hero) {
            hero.css('background-position-y', `calc(50% + ${scrollTop / 4}px)`);
        }
    });

    // Handle hero section
    const heroSection = $('.hero-section');
    if (heroSection.length) {
        heroSection.imagesLoaded({
            background: true
        }, () => {
            heroSection.find('.hero-section-preview').addClass('blurOut');
        });
        // Scroll to content
        heroSection.find('.hero-section-down').on('click', () => {
            $('html, body').animate({
                scrollTop: $('.supplier-search').offset().top
            }, 500);
        });
        // Play video on click
        const heroPlay = heroSection.find('.icon-play');
        if (heroPlay) {
            heroPlay.on('click', () => {
                setTimeout(() => {
                    $(window).trigger('resize');
                    $('.mejs-overlay-button').trigger('click');
                }, 300);
            });
        }
    }

    // Scroll to top
    toTop.on('click', () => {
        $('html, body').animate({
            scrollTop: 0
        }, 500);
    });

    // Animate in h1 flare
    inView.offset(100);
    inView('h1, .long-hero-title').on('enter', (el) => {
        $(el).addClass('drawIn');
    });

    // Animate in fadeOut items
    inView.offset(100);
    inView('.fadeOut').on('enter', (el) => {
        $(el).addClass('fadeIn');
    });

    // Simple image slider
    $('.image-slider').slick({
        adaptiveHeight: true,
        prevArrow: '<i class="fa fa-angle-left arrow-left"></i>',
        nextArrow: '<i class="fa fa-angle-right arrow-right"></i>'
    });

    // Masonry Gallery
    var gallery = $('.gallery');
    if (gallery.length) {
        gallery.imagesLoaded(() => {
            gallery.masonry({
                itemSelector: '.gallery-item'
            });
        });
    }

})(jQuery);
